const fidelityRetirementScoreChartConfig = {
  title: {
    text: '<b>150</b><br>(Your Score)',
    align: 'center',
    verticalAlign: 'middle',
    y: 40,
    style: {
      color: '#FFF',
      fontWeight: 'bold'
    }
  },

  chart: {
    type: 'gauge',
    height: 270,
    width: 500,
    plotBackgroundColor: null,
    plotBackgroundImage: '/assets/img/status-gauge-bg.svg',
    plotBorderWidth: 0,
    plotShadow: false
  },

  pane: {
    startAngle: -90,
    endAngle: 90,
    center: ['50%', '98%'],
    background: null,
    size: 480
  },

  // the value axis
  yAxis: {
    min: 0,
    max: 150,

    minorTickInterval: null,

    tickPixelInterval: 50,
    tickWidth: 0,
    tickPosition: 'inside',
    tickLength: 0,
    tickColor: '#fff',
    labels: {
      step: 1,
      style: {
        color: '#000',
        fontSize: '10'
      },
      rotation: 'auto'
    },

    plotBands: [{
      from: 0,
      to: 65,
      color: '#333'
    }, {
      from: 65,
      to: 80,
      color: '#555'
    }, {
      from: 80,
      to: 95,
      color: '#777'
    }, {
      from: 95,
      to: 150,
      color: '#999'
    }]
  },
  plotOptions: {
    gauge: {
      dataLabels: {
        enabled: false
      },
      dial: {
        radius: '65%',
        backgroundColor: '#000',
        topWidth: 1,
        baseWidth: 20,
        rearLength: '-7%',
      },
      pivot: {
        radius: 12,
        borderWidth: 15,
        borderColor: '#000',
        backgroundColor: 'transparent'
      }
    }
  },
  exporting: {
    enabled: false
  },
  credits: {
    enabled: false
  },
  tooltip: {
    enabled: false
  },
  series: [{
    data: [60]
  }]

}
//   title: {
//     text: '<b>150</b><br>(Your Score)',
//     align: 'center',
//     verticalAlign: 'middle',
//     y: 40,
//     style: {
//       color: '#FFF',
//       fontWeight: 'bold'
//     }
//   },

//   chart: {
//     type: 'gauge',
//     height: 265,
//     width: 500,
//     plotBackgroundColor: null,
//     plotBackgroundImage: '/assets/img/status-gauge-bg.svg',
//     plotBorderWidth: 0,
//     plotShadow: false
//   },

//   exporting: {
//     enabled: false
//   },
//   credits: {
//     enabled: false
//   },
//   pane: {
//     startAngle: -90,
//     endAngle: 90,
//     center: ['50%', '98%'],
//     size: 800,
//     background: null
//   },
//   plotOptions: {
//     gauge: {
//       dataLabels: {
//         enabled: false
//       },
//       dial: {
//         radius: '37%',
//         backgroundColor: '#000',
//         topWidth: 1,
//         baseWidth: 20,
//         rearLength: '-7%',
//       },
//       pivot: {
//         radius: 12,
//         borderWidth: 15,
//         borderColor: '#000',
//         backgroundColor: 'transparent'
//       }
//     }
//   },
//   // the value axis
//   yAxis: {
//     min: 0,
//     max: 150
//   },
//   series: [{
//     data: [75],
//   }]
// }

function getFidelityRetirementScoreChartConfig(score: number) {
  const r = fidelityRetirementScoreChartConfig
  r.title.text = '<b>' + score + '</b><br>(Your Score)'
  r.series[0].data = [score]
  return r
}

export {
  getFidelityRetirementScoreChartConfig
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Results/charts/health/index.ts